import React from 'react'
import PropTypes from 'prop-types'
import { FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'

import * as styles from './styles'
import { getOptionLabel, getOptionValue } from './helpers'

const EditAthletesFormComponent = ({
  header,
  loadCategories,
  form,
  onSubmitRequest,
}) => (
  <EditableFormPanel header={header} form={form} onSubmit={onSubmitRequest}>
    {(editable) => (
      <>
        <Margin bottom={1} css={styles.row}>
          <Text as="label" size={11}>
            Name
          </Text>
          <FormInput
            strictLong
            name="name"
            placeholder="Name"
            css={styles.control}
            disabled={!editable}
          />
        </Margin>
        <Margin bottom={1} css={styles.row}>
          <Text as="label" size={11}>
            Surname
          </Text>
          <FormInput
            strictLong
            name="surname"
            placeholder="Surname"
            css={styles.control}
            disabled={!editable}
          />
        </Margin>
        <Margin bottom={1} css={styles.row}>
          <Text as="label" size={11}>
            Nationality
          </Text>
          <FormInput
            strictLong
            name="nationality"
            placeholder="Nationality"
            css={styles.control}
            disabled={!editable}
          />
        </Margin>
        <Margin bottom={1} css={styles.row}>
          <Text as="label" size={11}>
            Date Of Birth
          </Text>
          <FormInput
            strictLong
            name="dateOfBirth"
            placeholder="Date Of Birth"
            css={styles.control}
            disabled={!editable}
          />
        </Margin>
        <Margin bottom={1} css={styles.row}>
          <Text as="label" size={11}>
            Sport
          </Text>
          <FormInput
            strictLong
            cacheOptions
            defaultOptions
            isSearchable={false}
            getOptionLabel={getOptionLabel}
            getOptionValue={getOptionValue}
            type="async-select"
            name="sport"
            placeholder="Sport"
            loadOptions={loadCategories}
            css={styles.control}
            disabled={!editable}
          />
        </Margin>
        <FormInput name="logo" type="hidden" />
        <FormInput name="id" type="hidden" />
      </>
    )}
  </EditableFormPanel>
)

EditAthletesFormComponent.propTypes = {
  form: PropTypes.shape(),
  header: PropTypes.string.isRequired,
  initialValues: PropTypes.shape(),
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  loadCategories: PropTypes.func,
  onSubmitRequest: PropTypes.func,
}

export default EditAthletesFormComponent
